export default "__VITE_ASSET__DqJlg6ns__"